import Service from "./Service";
import { OrderEntity } from "@/model/Order";
export class orderService extends Service {
  path: string;
  constructor(name: string, path: string, root = "/api") {
    super(name, root);
    this.path = path;
  }

  CheckRepeatOrder(data: OrderEntity) {
    return this.post<OrderEntity>(`/${this.path}/CheckRepeatOrder`, data, {
      failTips: false,
    });
  }
  CreateOrder(data: OrderEntity) {
    return this.post<any>(`/${this.path}/CreateOrder`, data);
  }
  OrderDetails(UniqueID: string) {
    return this.get<any>(`/${this.path}/OrderDetails?UniqueID=${UniqueID}`);
  }
  OrderCancel(id: string) {
    return this.get<any>(`/${this.path}/OrderCancel?UniqueID=${id}`);
  }
  RefundJudge(UniqueID: string) {
    return this.get<any>(`/${this.path}/RefundJudge?UniqueID=${UniqueID}`);
  }
  CreateAmend(amend: any) {
    return this.post<any>(`/${this.path}/CreateAmend`, amend);
  }
  OrderSubmit(UniqueID: string) {
    return this.get<any>(`/${this.path}/OrderSubmit/${UniqueID}`);
  }
  UpdateOrderStatus(id: string) {
    return this.get<any>(`/${this.path}/UpdateOrderStatus?UniqueID=${id}`);
  }
  OrderRefund(data: any) {
    return this.post<any>(`/${this.path}/OrderRefund`, data);
  }
  getReplenishOrderInfomation(data: OrderEntity) {
    return this.post<OrderEntity>(`/${this.path}/ReplenishOrderInfomation`, data);
  }
  CreateOrderByPreference(data: any) {
    return this.post<any>(`/${this.path}/CreateOrderByPreference`, data);
  }
  SearchOrders(id: string) {
    return this.get<any>(`/${this.path}/SearchOrders?UniqueID=${id}`);
  }
  OrderRefundCancel(id: string) {
    return this.get<any>(`/${this.path}/OrderRefundCancel?UniqueID=${id}`);
  }
  // OrderChange(data: any) {
  //   return this.post<any>(`/${this.path}/FlightOrderChange`, data);
  // }
}
